import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { AgentiProiecteService } from '../agenti-proiecte.service';
import { NotificationService } from 'src/app/services/notification.service';
import { IAgentAddPayload, IAgentForm } from '../agenti-proiecte.interface';
import { finalize } from 'rxjs';
import { phoneValidator } from 'src/app/validators';

@Component({
    selector: 'app-add-agenti-proiecte',
    templateUrl: './add-agenti-proiecte.component.html',
    styleUrls: ['./add-agenti-proiecte.component.scss']
})
export class AddAgentiProiecteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        telefon: new FormControl('', [Validators.required, phoneValidator()]),
        observatii: new FormControl('', []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddAgentiProiecteComponent>,
        private agentiProiecteService: AgentiProiecteService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, telefon, observatii } = this.form.value as IAgentForm;
        const payload: IAgentAddPayload = {
            name,
            telefon,
            observatii
        };

        this.agentiProiecteService
            .addAgent(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
